import { RushGlide } from './_rush-glide';
import { isMobile } from '../services/mql-service';

export class RelatedLocations extends DrupalBehavior {
  onContent(context) {
    const relatedLocations = document.querySelector('.related-locations');
    this.setUpRelatedLocationsSlider(relatedLocations);
    sliders.forEach((slider) => {
      const rushGlide = new RushGlide();
      rushGlide.setUpGlide(slider, {
        breakpoints: {
          991: {},
        },
      });
    });
  }

  setUpRelatedLocationsSlider(relatedLocations) {
    const rushGlide = new RushGlide();
    if (isMobile()) {
      this.setUpMobileSlider(rushGlide, relatedLocations);
    } else {
      this.setUpDesktopSlider(rushGlide, relatedLocations);
    }
  }

  setUpMobileSlider(rushGlide, relatedLocations) {
    const mobilePeekPixels = 39;
    const slider = relatedLocations.querySelector(
      '.mobile-only .related-locations--slider-wrap'
    );
    rushGlide.setUpGlide(slider, {
      gap: 16,
      startPeek: { before: 0, after: mobilePeekPixels },
      endPeek: { before: mobilePeekPixels, after: 0 },
      perView: 1,
      customArrows: {
        leftArrow: relatedLocations.querySelector(
          '.mobile-only .glide__arrow--left'
        ),
        rightArrow: relatedLocations.querySelector(
          '.mobile-only .glide__arrow--right'
        ),
      },
    });
  }

  setUpDesktopSlider(rushGlide, relatedLocations) {
    const desktopPeekPixels = 68;
    const desktopPadding = 20;

    const slider = relatedLocations.querySelector(
      '.desktop-only .related-locations--slider-wrap'
    );
    rushGlide.setUpGlide(slider, {
      perView: 2,
      startPeek: { before: desktopPadding, after: desktopPeekPixels },
      endPeek: { before: desktopPeekPixels, after: desktopPadding },
      gap: 24,
    });
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'related_locations',
  RelatedLocations
);
